import styled from 'styled-components';

export const VisulizationContainer = styled.div`
  flex-grow: 1;
  min-height: 360px;
  max-height: 440px;
  min-width: 0;
`;
